import { useBrowserSearch } from '@/hooks/useBrowserSearch';
import { useLocalizedPath } from '@/hooks/useLocalizedPath';

export function useLandingNavigationPaths() {
  const search = useBrowserSearch() ?? '';
  const localizedPath = useLocalizedPath();

  return {
    localizedPath,
    withSearch: (path: string) => `${path}${search}`,
    homeHash: (hash: string) => `${localizedPath('/')}${search}${hash}`,
  };
}
